<template>
  <div class="container">
    <div class="register-page">
      <div class="header"><span>Register</span></div>
      <div class="content">
        <RegisterForm @success="handleRegisterSuccess" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import RegisterForm from "@/components/account/RegisterForm.vue";

export default {
  name: "RegisterPage",
  components: {
    RegisterForm,
  },
  computed: {
    ...mapState("auth", ["multipassAccount"]),
  },
  methods: {
    handleRegisterSuccess() {
      window.location.url = this.multipassAccount.url;
    },
  },
};
</script>

<style lang="scss" scoped>
.register-page {
  text-align: center;
  width: 100%;
  max-width: 500px;
  margin: 30px auto 0;
  border: 1px solid rgba($color-dark, 0.2);

  .header {
    padding: 0 20px;
    font-size: 16px;
    font-family: $heading-font-family;
    text-transform: uppercase;
    background-color: $color-light;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @include respond-above(md) {
      flex: 0 0 auto;
    }

    & > span {
      padding: 16px 0;
    }
  }

  .content {
    padding: 16px;
    text-align: left;
  }
}
</style>
